import type { Offer } from '@libs/common-types';

const AUTOSHIP_POINTS_OFFER_NAME_REGEX = /^(\d+)_AUTOSHIP_PO_([A-Za-z0-9]+)_(\d+)(?:_T)?$/;
const AUTOSHIP_POINTS_PAYOUT_REWARD_NAME = 'autoship points payout';

export function isAutoshipPointsPayoutOffer(offer?: Offer | null): boolean {
    if (!offer?.name) {
        return false;
    }

    return AUTOSHIP_POINTS_OFFER_NAME_REGEX.test(offer.name);
}

export function getActivateRewardSelection({
    offer,
    isAsPointsPayoutCtaEnabled,
    activateOfferIdFromUrl,
}: {
    offer: Offer;
    isAsPointsPayoutCtaEnabled: boolean;
    activateOfferIdFromUrl?: string | null;
}): string {
    const isAutoshipActivationFlow = activateOfferIdFromUrl === offer.offerId;

    if (isAsPointsPayoutCtaEnabled && isAutoshipActivationFlow && isAutoshipPointsPayoutOffer(offer)) {
        return AUTOSHIP_POINTS_PAYOUT_REWARD_NAME;
    }

    return offer.shortDescription;
}
